import { useMemo } from 'react';
import { useAvailableUIFeatures } from '../../../../core/permissions/has-permissions.hook';
import { useSettingsTreePanelProps } from '../../hooks/settings-tree-props.hook';
import { buildSettingsTree } from '../../mappings/build-settings-tree';
import { useSettingsTreeReducerContext } from '../../reducer/settings-tree-reducer.context';
import { SettingsTreePanel } from './settings-tree-panel.component';

export function SettingsTreePanelContainer() {
  const reducer = useSettingsTreeReducerContext();
  const availableUiFeatures = useAvailableUIFeatures();
  const settingsTree = useMemo(
    () =>
      buildSettingsTree(
        reducer.state.projectTree,
        reducer.state.projectChildrenTree,
        reducer.state.placeholderNodes,
        availableUiFeatures
      ),
    [reducer.state.projectTree, reducer.state.projectChildrenTree, reducer.state.placeholderNodes, availableUiFeatures]
  );
  const settingsTreeProps = useSettingsTreePanelProps(settingsTree.root, reducer.dispatch, reducer.state);

  if (!settingsTreeProps) {
    return null;
  }

  return <SettingsTreePanel {...settingsTreeProps} isLoadingChildren={reducer.projectChildrenLoading} />;
}
